export default {"src":"/_next/static/media/tripadvisor.71948aa0.svg","height":84,"width":75,"blurWidth":0,"blurHeight":0};